import { wireAreaFromDiameter } from "../weldParameter/formulas";
import type { WireMaterialInputs, WireMaterialResult } from "./types";

export function calculateWireMaterial(inputs: WireMaterialInputs): WireMaterialResult {
  const wireArea = wireAreaFromDiameter(inputs.wireDiameter);
  const weightPerMeter = wireArea * inputs.density;
  const wireLength = inputs.spoolWeight > 0 && weightPerMeter > 0 ? (inputs.spoolWeight * 1000) / weightPerMeter : 0;
  const maxWeldTimeMinutes = inputs.wireFeed > 0 ? wireLength / inputs.wireFeed : 0;
  const depositionRate = (wireArea * inputs.density * inputs.wireFeed * 60) / 1000;
  const wireConsumption = wireArea * (inputs.wireFeed / 60) * inputs.weldingTime * inputs.density;

  return {
    wireLength,
    maxWeldTimeMinutes,
    depositionRate,
    wireConsumption,
    wireArea,
    weightPerMeter
  };
}
